import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Template {
    templateList(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.multipleTempleteList}?${params}`)
    }

    getPublicTemplateList(filter) {
        const params = CommonUtility.objectToParams(filter)
        return BaseService.get(`${APIPath.publicTempleteList}?${params}`)
    }

    reopenReport(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.post(`${APIPath.templateStatus}?${params}`)
    }

    getTemplateDetails(id) {
        return BaseService.get(`${APIPath.templeteDetails}${id}`)
    }

    getTemplateSetting(templateId) {
        return BaseService.get(`${APIPath.templateSetting}/${templateId}`)
    }

    saveTemplateSetting(data) {
        return BaseService.post(APIPath.templateSettingSave, data)
    }

    getPastInspections(templateId, customerId) {
        return BaseService.get(
            `${APIPath.templatePastInspections(
                templateId,
            )}?customerId=${customerId}`,
        )
    }

    getPublicTemplateDetails(id, options = {}) {
        let url = `${APIPath.publictempleteDetails}${id}`;
        const params = [];
        if (options.IsAddToLibrary) {
            params.push('IsAddToLibrary=true');
        }
        if (params.length) {
            url += (url.includes('?') ? '&' : '?') + params.join('&');
        }
        return BaseService.get(url);
    }

    async copyInspectionFromTemplate(templateId) {
        return BaseService.post(`${APIPath.librarypublictemplete}${templateId}`)
    }

    getsortBy() {
        return BaseService.get(`${APIPath.sortBy}`)
    }

    getMultipleResposes(data) {
        return BaseService.get(`${APIPath.multipleResponses}`, data)
    }

    removeMultiResponse(id) {
        return BaseService.remove(`${APIPath.multipleResponses}/${id}`)
    }

    removeTemplate(id) {
        return BaseService.post(`${APIPath.removeTemplate}/${id}/Remove`)
    }

    getMasterResponse() {
        return BaseService.get(`${APIPath.masterResponse}`)
    }

    getTemplateType() {
        return BaseService.get(`${APIPath.templeteType}`)
    }

    getPublicTemplateType() {
        return BaseService.get(`${APIPath.publictempleteType}`)
    }

    async create(data) {
        if (data.templateId) {
            await this.copyInspectionFromTemplate(data.templateId)
        }
        return BaseService.post(`${APIPath.template}`, data)
    }

    async updateTemplate(data) {
        // Use the new Update endpoint for all companies
        return BaseService.post(APIPath.templateUpdate, data)
    }

    checkFormula(data) {
        return BaseService.post(APIPath.formulaCheck, data)
    }

    updateSectionName({ TemplateId, SectionId, SectionName }) {
        return BaseService.putExact(APIPath.templateSection, {
            TemplateId,
            SectionId,
            SectionName,
        })
    }

    sendTemplateEmail(data) {
        // Important: Do not generate a token here - use the token provided by the backend
        // The backend will generate the token and include it in the response
        console.log('Sending email template data:', data)

        // Send just the required fields to the backend
        const emailData = {
            Emails: data.Emails,
            TemplateId: data.TemplateId,
            IsActive: data.IsActive,
            DueDate: data.DueDate,
            TemplateName: data.TemplateName,
        }

        return BaseService.post(`${APIPath.sendEmail}`, emailData)
    }

    sendTemplateEmailWithPDF(data) {
        // Send email with PDF attachment (Base64 encoded)
        console.log('📧 API Call - sendTemplateEmailWithPDF - Input Data:', {
            Emails: data.Emails,
            TemplateId: data.TemplateId,
            TemplateName: data.TemplateName,
            PdfBase64Length: data.PdfBase64 ? data.PdfBase64.length : 0,
            PdfBase64Preview: data.PdfBase64 ? `${data.PdfBase64.substring(0, 50)}...` : null,
        })

        const emailData = {
            Emails: data.Emails,
            TemplateId: data.TemplateId,
            TemplateName: data.TemplateName,
            PdfBase64: data.PdfBase64, // Base64 encoded PDF string
        }

        console.log('📧 API Call - sendTemplateEmailWithPDF - Request Payload:', emailData)
        console.log('📧 API Call - sendTemplateEmailWithPDF - API Endpoint:', `${APIPath.sendEmailWithPDF}`)

        return BaseService.post(`${APIPath.sendEmailWithPDF}`, emailData)
    }

    updateTemplateEmail(data) {
        return BaseService.put(`${APIPath.updateEmail}`, data)
    }

    deleteTemplateEmail(id) {
        return BaseService.post(`${APIPath.deleteEmail}${id}`)
    }

    getEmailsByTemplateId(templateId) {
        return BaseService.get(`${APIPath.getEmailsByTemplateId}${templateId}`)
    }

    getEmailById(id) {
        return BaseService.get(`${APIPath.getEmailById}${id}`)
    }

    saveTemplateMultiResponse(choice) {
        return BaseService.post(APIPath.multiResponses, choice)
    }

    updateTemplateMultiResponse(choice) {
        return BaseService.put(APIPath.updateMultipleResponse, choice)
    }

    getCompanyTemplate() {
        return BaseService.get(`${APIPath.companyTemplate}`)
    }

    getMultiResponceTypes() {
        return BaseService.get(`${APIPath.multiResponceType}`)
    }

    sort(data) {
        return BaseService.post(`${APIPath.templateOrder}`, data)
    }

    cloneTemplate(data) {
        return BaseService.post(`${APIPath.cloneTemplate}`, data)
    }

    // Template Group APIs
    getTemplateGroups(companyId) {
        // Use GET for listing groups, no body
        return BaseService.get(`${APIPath.templateGroup}?companyId=${companyId}`)
    }

    createTemplateGroup(data) {
        // data: { TemplateGroupIds, CompanyId }
        // API expects TemplateGroupIds (semicolon-separated), CompanyId
        return BaseService.post(`${APIPath.templateGroup}`, {
            TemplateGroupIds: data.TemplateGroupIds,
            TemplateGroupName: data.TemplateGroupName,
            CompanyId: data.CompanyId,
        })
    }

    updateTemplateGroup(data) {
        // data: { TemplateGroupIds, TemplateGroupName, TemplateGroupId }
        // API expects TemplateGroupIds (semicolon-separated), TemplateGroupName, TemplateGroupId
        return BaseService.post(`${APIPath.templateGroupUpdate}`, {
            TemplateGroupIds: data.TemplateGroupIds,
            TemplateGroupName: data.TemplateGroupName,
            ...(data.TemplateGroupId && { TemplateGroupId: data.TemplateGroupId }),
        })
    }

    filterTemplateGroups(companyId, filter) {
        // filter: { TemplateGroupIds, TemplateGroupName }
        return BaseService.get(
            `${APIPath.templateGroup}?companyId=${companyId}`,
            filter,
        )
    }

    getTemplateGroupById(groupId) {
        return BaseService.get(`${APIPath.templateGroupById}${groupId}`)
    }

    getMultiResponsesByTemplateAndGroup(templateId, groupId) {
        return BaseService.get(
            `${APIPath.getMultiResponsesByTemplateAndGroup}${templateId}/${groupId}`,
        )
    }

    // Template Combine APIs - Sequence Group
    getSequenceGroupsByCompany(companyId, onlyActive = true) {
        const params = CommonUtility.objectToParams({ companyId, onlyActive })
        return BaseService.get(`${APIPath.sequenceGroupGetByCompany}?${params}`)
    }

    getSequenceGroupById(sequenceGroupId) {
        return BaseService.get(`${APIPath.sequenceGroupGetById}/${sequenceGroupId}`)
    }

    saveSequenceGroup(data) {
        // data: { SequenceGroupId, GroupName, CompanyId, Description, IsActive }
        // For update, set SequenceGroupId > 0. For create, use 0.
        return BaseService.post(`${APIPath.sequenceGroupSave}`, data)
    }

    deleteSequenceGroup(sequenceGroupId) {
        return BaseService.post(`${APIPath.sequenceGroupDelete}/${sequenceGroupId}`, {})
    }

    // Template Combine APIs - Sequence Detail
    getSequenceDetailsByGroupId(sequenceGroupId, onlyActive = true) {
        const params = CommonUtility.objectToParams({ sequenceGroupId, onlyActive })
        return BaseService.get(`${APIPath.sequenceDetailGetByGroupId}?${params}`)
    }

    getSequenceDetailsByTemplate(templateUniqueId, onlyActive = true) {
        const params = CommonUtility.objectToParams({ templateUniqueId, onlyActive })
        return BaseService.get(`${APIPath.sequenceDetailGetByTemplate}?${params}`)
    }

    saveSequenceDetail(data) {
        // data: { SequenceDetailId, SequenceGroupId, TemplateUniqueId, SequenceOrder, IsMandatory, IsActive }
        // For update, set SequenceDetailId > 0. For create, use 0.
        return BaseService.post(`${APIPath.sequenceDetailSave}`, data)
    }

    deleteSequenceDetail(sequenceDetailId) {
        return BaseService.post(`${APIPath.sequenceDetailDelete}/${sequenceDetailId}`, {})
    }

    // Template Combine APIs - Mapping
    getMappingsByTarget(templateUniqueId, onlyActive = true) {
        const params = CommonUtility.objectToParams({ templateUniqueId, onlyActive })
        return BaseService.get(`${APIPath.mappingGetByTarget}?${params}`)
    }

    getMappingsBySource(templateUniqueId, onlyActive = true) {
        const params = CommonUtility.objectToParams({ templateUniqueId, onlyActive })
        return BaseService.get(`${APIPath.mappingGetBySource}?${params}`)
    }

    getMappingById(mappingId) {
        return BaseService.get(`${APIPath.mappingGetById}/${mappingId}`)
    }

    saveMapping(data) {
        // data: { MappingId, SourceTemplateUniqueId, SourceQuestionUniqueId, TargetTemplateUniqueId, TargetQuestionUniqueId, IsAutoPopulate, IsActive }
        // For update, set MappingId > 0. For create, use 0.
        return BaseService.post(`${APIPath.mappingSave}`, data)
    }

    deleteMapping(mappingId) {
        return BaseService.post(`${APIPath.mappingDelete}/${mappingId}`, {})
    }

    // Template Combine APIs - Previous Template
    getPreviousTemplate(auditTemplateId, templateId, createdBy, customerId) {
        const payload = {
            AuditTemplateId: auditTemplateId,
            TemplateId: templateId,
            CreatedBy: createdBy,
            CustomerId: customerId,
        }
        return BaseService.post(APIPath.previousTemplate, payload)
    }
}

const TemplateService = new Template()
Object.freeze(TemplateService)
export { TemplateService }
